import React, { useEffect, useState } from "react";
import Total from "../../assets/dashboard/total.png";
import order from "../../assets/svg/orderss.svg";
import Delivery from "../../assets/dashboard/delivery.png";
import Ongoing from "../../assets/dashboard/ongoing.png";
import ThreeDot from "../../icons/ThreeDot";
import { Increase } from "../../icons/Increase";
import { useQuery } from "@tanstack/react-query";
import { getQuotes } from "../../lib/quotes";
import Popup from "../login/Popup";
import { useMyContext } from "../../context/MyContext";
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";
import TermsModal from "../termsAndConditions/TermsModal";

const Statistics = ({
  deliveredShipments,
  ongoingShipments,
  totalShipments,
  lastMonthShipments,
  previousTotalShipments,
  previousOngoingShipments,
  previousDeliveredShipments,
  previousLastMonthShipments
}) => {
  const { user, showTermsModal, setShowTermsModal, open, setOpen, termsAccepted } = useMyContext();
  const userRole = user.role;

  // Terms modal visibility is now fully controlled by MyContext

  const calculatePercentageChange = (current, previous) => {
    if (previous === undefined || previous === null || isNaN(previous) || previous === 0) {
      return current > 0 ? 'New' : '-';
    }
    const change = ((current - previous) / previous) * 100;
    const sign = change >= 0 ? '+' : '-';
    return `${sign}${Math.min(Math.abs(change), 100).toFixed(2)}%`;
  };

  const stats = [
    {
      text: "Total Shipments",
      number: `${totalShipments || 0}`,
      percentage: calculatePercentageChange(totalShipments, previousTotalShipments),
      background: "rgba(17, 108, 238, 0.12)",
      // background: "white",
      month: previousTotalShipments !== undefined ? "vs last month" : "No previous data",
      increase: totalShipments > (previousTotalShipments || 0),
      icon: Total,
    },
    {
      text: "Ongoing Shipments",
      number: `${ongoingShipments || 0}`,
      background: "rgba(80, 146, 104, 0.12)",
      // background: "white",

      percentage: calculatePercentageChange(ongoingShipments, previousOngoingShipments),
      month: previousOngoingShipments !== undefined ? "vs last month" : "No previous data",
      increase: ongoingShipments > (previousOngoingShipments || 0),
      icon: Ongoing,
    },
    {
      text: "Delivered Shipments",
      number: `${deliveredShipments || 0}`,
      background: "rgba(231, 50, 0, 0.12)",
      // background: "white",

      percentage: calculatePercentageChange(deliveredShipments, previousDeliveredShipments),
      month: previousDeliveredShipments !== undefined ? "vs last month" : "No previous data",
      increase: deliveredShipments > (previousDeliveredShipments || 0),
      icon: Delivery,
    },

    {
      text: "Amount Of Orders",
      number: `${lastMonthShipments || 0}`,
      background: "rgba(17, 108, 238, 0.12)",
      // background: "white",

      percentage: calculatePercentageChange(lastMonthShipments, previousLastMonthShipments),
      month: previousLastMonthShipments !== undefined ? "vs last month" : "No previous data",
      increase: lastMonthShipments > (previousLastMonthShipments || 0),
      icon: order,
    },
  ];

  return (
    <div className="flex flex-nowrap gap-4 bg-white p-4 rounded-lg overflow-x-auto">
      {stats.map((item, index) => (
        <div
          key={index}
          className="flex-1 min-w-[220px] bg-[#fff] rounded-lg border shadow-lg flex flex-col"
        >
          <div className="flex-1 p-5">
            <div className="flex space-x-4 flex-wrap items-start">
              <div
                className="rounded-full flex justify-center items-center w-[42px] h-[42px]"
                style={{ background: item.background }}
              >
                <img src={item.icon} alt="" width={"25px"} height={"15px"} />
              </div>
              <h1 className="text-black flex flex-col font-medium flex-1 text-sm">
                {item.text}
                <span className="text-black font-semibold text-lg">
                  {item.number}
                </span>
              </h1>
              {/* <ThreeDot /> */}
            </div>
            <div className="mt-5 flex items-center">
              {/* <h1 className="text-[#000] font-semibold text-[24px]">
                  {item.number}
                </h1> */}
              <div className="flex-1 flex space-x-2 justify-start flex-wrap items-center">
                <div
                  className={`${item.increase ? "text-[#7ce13e] bg-green-100" : "text-[#DA1C00] bg-red-100"} p-2 flex justify-center items-center rounded-full `}>
                  {item.increase ? <FaArrowTrendUp /> : <FaArrowTrendDown />}
                </div>
                {/* <Increase /> */}
                <p className={`${item.increase ? "text-[#7ce13e]" : "text-[#DA1C00]"}  text-[14px] font-normal`}>
                  {item.percentage}
                </p>
                <p className="text-[12px]">{item.month}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Statistics;